import { connect } from "react-redux";
import LearnerHomeWidgetBlock from "./learner-home-widget-block";
import { structure, single } from "../../../../core/store/actions/block";

const mapStateToProps = (state) => ({
  content: state.content,
  language: state.language,
  widgets: state.learnerHome.widgets,
});

const mapDispatchToProps = {
  structure,
  single,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LearnerHomeWidgetBlock);



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/learner-home-widget-block/learner-home-widget-block-container.js